import React from 'react'
import './footer.css'
import logo from './assets/logo.png'
const Footer = () => {
    
    return (
        <div id='Footer'>
            <div className='footer-upper'>
                <div>
                <img className='nav-img' src={logo} alt="logo" />
                <p>I am a frontend web developer looking for projects to work on and companies to serve in.</p>
                </div>
                <div className='subscribe'>
                    <input type="Email" className='email' placeholder='Enter your email' />
                    <button onClick={()=>{alert('Subscribed')}} className='sub-butt'>Subscribe</button>
                </div>
            </div>
            <hr />
            <div className='footer-lower'>
                <p>© 2024 Raghav Chandan | All rights reserved.</p>
                <p>Term of Services</p>
                <p>Privacy Policy</p>
                <p>Connect with me</p>
            </div>
        </div>
    )
}

export default Footer
